module.exports = __webpack_public_path__ + "static/media/nice_doct.3b3cc752.jpg";